export enum PhoneTypeEnum {
    Other = 0,
    Home = 1,
    Work = 2,
    //Mobile = 3,
    //Fax = 4
}
